const Footer = () => {
    return (
        <footer className="flex items-center justify-center px-6 pt-12 text-base mb-2">
           <p className="text-gray-700">Desarrollado por <a className="text-purple-700 focus:underline" href="https://github.com/marcelonieva7">Marcelo Nieva</a></p>
        </footer>
    )
}
 
export default Footer;